'use client';

import { observer } from 'mobx-react';
import React, { FC, useContext, useMemo } from 'react';
import { RootStoreContext } from '@stores/rootStore';
import { LFAsyncSelect } from '@app/_components/form-control/selects';
import { createAsyncOptionLoader } from '@app/_components/form-control/selects/createAsyncOptionLoader';
import { useQueryClient } from '@tanstack/react-query';
import { useLFSearchParams } from '@services/useLFSearchParams';
import { IOrganization } from '@stores/Organization';
export const OrganizationSwitcher: FC = observer(() => {
  const {
    uiStore,
    userStore,
    organizationsStore
  } = useContext(RootStoreContext);
  const {
    setParams
  } = useLFSearchParams();
  const queryClient = useQueryClient();
  const loadOptions = useMemo(() => createAsyncOptionLoader<IOrganization>(async ({
    page,
    search
  }) => {
    const response = await userStore.fetchOrganizations({
      page: page,
      search: search
    });
    return response || [];
  }, org => ({
    label: org.name,
    value: org.id
  })), [userStore]);
  const clearQueryParams = () => {
    setParams([{
      key: 'filter[year]',
      value: null
    }, {
      key: 'filter[province]',
      value: null
    }, {
      key: 'filter[district]',
      value: null
    }, {
      key: 'filter[village]',
      value: null
    }, {
      key: 'filter[subdistrict]',
      value: null
    }, {
      key: 'filter[country]',
      value: null
    }, {
      key: 'filter[season_id]',
      value: null
    }, {
      key: 'filter[crop]',
      value: null
    }, {
      key: 'filter[label_ids][]',
      value: null
    }]);
  };
  return <div className={`
        flex w-full flex-col p-6 px-12
        print:hidden
      `}>
      {uiStore.currentOrganization && organizationsStore.organizations.length > 1 && <LFAsyncSelect label="organization" loadOptions={loadOptions} value={{
      label: uiStore.currentOrganization.name,
      value: uiStore.currentOrganization.id
    }} onChange={val => {
      queryClient.clear();
      clearQueryParams();
      if (val?.value) {
        uiStore.setCurrentOrganizationId(String(val.value));
      }
    }} />}
    </div>;
});